"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _OneColumn = _interopRequireDefault(require("@rsuite/icon-font/lib/layout/OneColumn"));

// Generated by script, don't edit it please.
var OneColumn = (0, _createSvgIcon["default"])({
  as: _OneColumn["default"],
  ariaLabel: 'one column',
  category: 'layout',
  displayName: 'OneColumn'
});
var _default = OneColumn;
exports["default"] = _default;
module.exports = exports.default;